var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFactCheckSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2091 4.26367H3.79091C3.18332 4.26367 2.60062 4.50503 2.17099 4.93466C1.74136 5.36429 1.5 5.94699 1.5 6.55457V17.2455C1.5 17.853 1.74136 18.4357 2.17099 18.8654C2.60062 19.295 3.18332 19.5364 3.79091 19.5364H20.2091C20.8167 19.5364 21.3994 19.295 21.829 18.8654C22.2586 18.4357 22.5 17.853 22.5 17.2455V6.55457C22.5 5.94699 22.2586 5.36429 21.829 4.93466C21.3994 4.50503 20.8167 4.26367 20.2091 4.26367Z",
    stroke: "#9393B0",
    strokeWidth: 1.43182,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31836 14.7639H10.0911M5.31836 11.9002H10.0911M5.31836 9.03662H10.0911",
    stroke: "#9393B0",
    strokeWidth: 1.43182,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9551 11.8998L14.8642 13.8089L18.6824 9.99072",
    stroke: "#9393B0",
    strokeWidth: 1.43182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactCheckSvgrepocom);
export default __webpack_public_path__ + "static/media/fact-check_svgrepo.com.8568a15bef444507ab0217fabdf14f59.svg";
export { ForwardRef as ReactComponent };